// extracted by mini-css-extract-plugin
export default {"rdblock":"jE","container":"kE","rddesc":"lE","title":"mE","copy":"nE","image":"oE","tipview":"pE","rdtip":"qE"};
    if(module.hot) {
      // 1715188236312
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  